import { lazy } from "react";

const AppRoutes = lazy(() => import("./AppRoutes"));

export const App = () => {
  return <AppRoutes />;
};
